import { render, staticRenderFns } from "./birthDay.vue?vue&type=template&id=5db13e28&scoped=true&"
import script from "./birthDay.vue?vue&type=script&lang=js&"
export * from "./birthDay.vue?vue&type=script&lang=js&"
import style0 from "./birthDay.vue?vue&type=style&index=0&id=5db13e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db13e28",
  null
  
)

export default component.exports